import React from "react";
import About from "../components/About";
import Box from "../components/Box";
import ChatBox from "../components/ChatBox";
import GifBox from "../components/GifBox";
import Poster from "../components/Poster";
import PosterMetrics from "../components/PosterMetrics";
import SubmitBox from "../components/SubmitBox";

export default function IndexPage() {
  return (
    <div style={{ height: "100%" }}>
      <main
        style={{
          padding: "1rem",
          background: "skyblue",
          width: "100%",
          minHeight: "100%",
          maxWidth: "80rem",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            textAlign: "center",
            margin: "1rem 0 2rem",
            fontWeight: "bold",
            fontSize: "1.5rem",
          }}
        >
          <h1>Something Good About 2020</h1>
          <h5>
            A Visual Time Capsule & Annual{" "}
            <span className="spinThisShit">Frank</span> Tradition
          </h5>
        </div>

        <div className="grid-wrapper">
          <div className="intro-box">
            <About />
            <PosterMetrics />
          </div>
          <div className="fun-box">
            <ChatBox />
            <GifBox />
          </div>
          <div className="poster-box">
            <Poster />
            <SubmitBox />

            {/* <Box
              title="THIS IS WHERE THE POSTER IS SUPPOSED TO GO"
              backgroundColor="white"
            >
              Hi. The poster site is currently broken because Frank is a dummy
              that tried to serve a 30MB+ file to your browser.
              <p>Please check back again, tomorrow. :)</p>- Frank (12/1/4:02PM)
            </Box> */}
          </div>
        </div>
      </main>
    </div>
  );
}
